import { action } from 'mobx';

import { ModalStore } from 'ui/base/modal';
import { BooleanStore, StringStore, GenericStore } from 'ui/base/input';

import { createRangeFilter } from 'ui/history/protocol_entry/protocol_entry_logic';
import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';

import { TransportProtocolFilter } from 'services/pangolin/types';

import { TransportProtocol } from 'assets/enums/protocols/protocols';

class TransportProtocolStore extends GenericStore<TransportProtocol|undefined> {}

export class RangeInputStore {
  search: SearchInputStore;

  protocol: TransportProtocolStore;
  portFirst: StringStore;
  portFinal: StringStore;

  modal: ModalStore;
  isValid: BooleanStore;

  constructor() {
    this.search = new SearchInputStore();
    this.protocol = new TransportProtocolStore(undefined);
    this.portFirst = new StringStore('');
    this.portFinal = new StringStore('');
    this.modal = new ModalStore(false);
    this.isValid = new BooleanStore(true);
  }

  @action.bound
  commit(): TransportProtocolFilter | undefined {
    if (/^[0-9]+$/.test(this.portFirst.value) &&
        /^[0-9]+$/.test(this.portFinal.value)) {
      const portFirst = parseInt(this.portFirst.value);
      const portFinal = parseInt(this.portFinal.value);
      if (!isNaN(portFirst) && !isNaN(portFinal) &&
          0 <= portFirst && portFirst <= 65535 &&
          0 <= portFinal && portFinal <= 65535) {
        this.isValid.setValue(true);
        return createRangeFilter(this.protocol.value,
                                 portFirst, portFinal);
      }
    }
    this.isValid.setValue(false);
    return undefined;
  }

  @action.bound
  showModal() {
    this.protocol.setValue(undefined);
    this.portFirst.setValue('');
    this.portFinal.setValue('');
    this.isValid.setValue(true);
    this.modal.showModal();
  }

  @action.bound
  hideModal() {
    this.modal.hideModal();
  }

  @action.bound
  toggleModal() {
    this.modal.visible = !this.modal.visible;
  }
}
